/** Reason + next human verb for anything that is not moving. Pure; unit-tested. */

export interface FeelBlocker {
  code: string;
  detail: string;
  nextAction: string;
  fix?: { label: string; href: string } | null;
  /** `you` | `amy` | `customer` when the API sends it. */
  owner?: string;
}

const isHumanVerb = (b: FeelBlocker) =>
  b.code !== 'needs_review' && !/^\s*none\b/i.test(b.nextAction);

/** The first blocker a person can act on: skips review noise and “None; …” waits, prefers ones owned by you. */
export function stuckVerb(blockers: readonly FeelBlocker[] | undefined | null): {
  reason: string;
  verb: string;
  href?: string;
  fixLabel?: string;
} | null {
  const actionable = (blockers ?? []).filter(isHumanVerb);
  if (!actionable.length) return null;
  const top = actionable.find(b => b.owner === 'you') ?? actionable[0]!;
  const fix = top.fix;
  return {
    reason: top.detail,
    verb: top.nextAction,
    ...(fix?.href ? { href: fix.href, fixLabel: fix.label } : {}),
  };
}
